import styles from './Home.css.js';
import { Tabs, Tab } from '@mui/material';
import { useState } from 'react';
import Articles from '../Articles/Articles.jsx';
import Pages from '../Pages/Pages.jsx';
// import Statistics from '../Statistics/Statistics';

function Home() {
    const [selectedTab, setSelectedTab] = useState(0);

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <div style={styles.root}>
            {/* RIGHT */}
            <div style={styles.rigth}></div>
            {/* CENTER */}
            <div style={styles.center}>
                <Tabs value={selectedTab} onChange={handleChange} style={styles.tabs.root}>
                    <Tab label='Articles' />
                    <Tab label='Pages' />
                    {/* <Tab label='Statistics' /> */}
                </Tabs>
                {selectedTab === 0 && <Articles />}
                {selectedTab === 1 && <Pages />}
                {/* {selectedTab === 2 && <Statistics />} */}
            </div>
            {/* LEFT */}
            <div style={styles.left}></div>
        </div>
    );
}

export default Home;
